// Source: https://github.com/supertokens/supertokens-auth-react/blob/master/examples/with-next-iframe/config/windowHandler.js

import { redirectTo } from 'config/navigation';

let inmemstorage: any = {};

export default function getWindowHandler(original: any) {
  return {
    ...original,
    localStorage: {
      ...original.localStorage,
      clear: async () => {
        try {
          return window ? window.localStorage.clear() : null;
        } catch (err) {
          inmemstorage = {};
        }
      },
      clearSync: () => {
        try {
          return window.localStorage.clear();
        } catch (err) {
          inmemstorage = {};
        }
      },
      getItem: async (key: string) => {
        try {
          return window ? window.localStorage.getItem(key) : null;
        } catch (err) {
          return inmemstorage[key] === undefined ? null : inmemstorage[key];
        }
      },
      getItemSync: (key: string) => {
        try {
          return window.localStorage.getItem(key);
        } catch (err) {
          return inmemstorage[key] === undefined ? null : inmemstorage[key];
        }
      },
      key: async (index: number) => {
        try {
          return window.localStorage.key(index);
        } catch (err) {
          return Object.keys(inmemstorage)[index];
        }
      },
      keySync: (index: number) => {
        try {
          return window.localStorage.key(index);
        } catch (err) {
          return Object.keys(inmemstorage)[index];
        }
      },
      removeItem: async (key: string) => {
        try {
          return window.localStorage.removeItem(key);
        } catch (err) {
          delete inmemstorage[key];
        }
      },
      removeItemSync: (key: string) => {
        try {
          return window.localStorage.removeItem(key);
        } catch (err) {
          delete inmemstorage[key];
        }
      },
      setItem: async (key: string, value: string) => {
        try {
          return window.localStorage.setItem(key, value);
        } catch (err) {
          inmemstorage[key] = value;
        }
      },
      setItemSync: (key: string, value: string) => {
        try {
          return window.localStorage.setItem(key, value);
        } catch (err) {
          inmemstorage[key] = value;
        }
      },
    },
    location: {
      ...original.location,
      setHref: (href: string) => {
        redirectTo(href);
      },
    },
  };
}
